module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "block-small-media live-video-container"
  }, [(_vm.isPostponed) ? _c('span', [_c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textPostponed))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.item.altText
    }
  })]) : _c('a', {
    staticClass: "video-play-button small",
    attrs: {
      "href": _vm.item.videoLink
    }
  }, [(_vm.isBefore) ? _c('div', {
    staticClass: "live-video-meta time active"
  }, [_vm._v(_vm._s(_vm.textClock) + " " + _vm._s(_vm.item.startTime))]) : (_vm.isActive) ? _c('div', {
    staticClass: "live-video-meta live active"
  }, [_vm._v(_vm._s(_vm.textLive))]) : _c('div', {
    staticClass: "live-video-meta rec active"
  }, [_vm._v(_vm._s(_vm.textRecording))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.item.altText
    }
  })])]), _vm._v(" "), _c('slider-item-information', {
    attrs: {
      "item": _vm.item
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afd59be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItemLink.vue
// module id = 97
// module chunks = 1